import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import asides from '../../routes/asideRoutes';
import PageWrapper from '../PageWrapper/PageWrapper';
import SubHeader from '../SubHeader/SubHeader';
import Page from '../Page/Page';
import Card, { CardBody } from '../../components/bootstrap/Card';

const LOADING = (
	<PageWrapper>
		<SubHeader>
			<div />
		</SubHeader>
		<Page>
			<div className='row h-100'>
				<div className='col-lg-6'>
					<Card stretch>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
				<div className='col-lg-6'>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
			</div>
		</Page>
	</PageWrapper>
);
const AsideRoutes = () => {
	return (
		<Suspense fallback={LOADING}>
			<Routes>
				{asides.map((page) => (
					// eslint-disable-next-line react/jsx-props-no-spreading
					<Route key={page.path} {...page} />
				))}
			</Routes>
		</Suspense>
	);
};

export default AsideRoutes;
